//Auth0
import Auth0Callback from '../Pages/Auth0/Auth0Callback';

//Login
import IndexLogIn from '../Pages/LogIn/Index';
import BuscarEmailConDni from '../Pages/LogIn/BuscarEmailConDni/BuscarEmailConDni';

import Error404 from '../Pages/Error404';
import Auth0Login from '../Pages/Auth0/Auth0Login';
import Auth0EmailConfirmation from '../Pages/Auth0/Auth0EmailConfirmation';
import Auth0Logout from '../Pages/Auth0/Auth0Logout';
import Auth0Register from '../Pages/Auth0/Auth0Register';
import Auth0LogoutCallback from '../Pages/Auth0/Auth0LogoutCallback';
import Auth0CallbackResetPassword from '../Pages/Auth0/Auth0CallbackResetPassword';
import Auth0GoogleLogin from '../Pages/Auth0/Auth0GoogleLogin';

const Routes = [
    {
        path: '/auth0-callback',
        component: Auth0Callback
    },
    {
        path: '/auth0-login',
        component: Auth0Login
    },
    {
        path: '/auth0-emailConfirmation',
        component: Auth0EmailConfirmation
    },
    {
        path: '/auth0-logout',
        component: Auth0Logout,
    },
    {
        path: '/auth0-logout-callback',
        component: Auth0LogoutCallback
    },
    {
        path: '/auth0-callback-reset-password',
        component: Auth0CallbackResetPassword
    },
    {
        path: '/auth0-google-login',
        component: Auth0GoogleLogin
    },
    {
        path: '/login',
        component: IndexLogIn,
        routes: [
            {
                path: '/login/registracion',
                component: Auth0Register,
            },
            {
                path: '/login/buscar-con-dni', 
                component: BuscarEmailConDni,
            },
        ],
    },
    
    {
        path: '/not-found',
        component: Error404,
    },
];

export default Routes;
